module.exports = __webpack_public_path__ + "static/media/ai-icon-outlined.86e66c8b.svg";